var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" I will fill up the available width and push everything else to my left and my right. ")])}
var staticRenderFns = []

export { render, staticRenderFns }